import listActions from 'src/modules/categoriaFormulario/list/categoriaFormularioListActions';
import CategoriaFormularioService from 'src/modules/categoriaFormulario/categoriaFormularioService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'CATEGORIAFORMULARIO_DESTROY';

const categoriaFormularioDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaFormularioDestroyActions.DESTROY_STARTED,
      });

      await CategoriaFormularioService.destroyAll([id]);

      dispatch({
        type: categoriaFormularioDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.categoriaFormulario.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/categoria-formulario');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: categoriaFormularioDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaFormularioDestroyActions.DESTROY_ALL_STARTED,
      });

      await CategoriaFormularioService.destroyAll(ids);

      dispatch({
        type: categoriaFormularioDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.categoriaFormulario.destroyAll.success'),
      );

      getHistory().push('/categoria-formulario');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: categoriaFormularioDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default categoriaFormularioDestroyActions;
